import { useBaseMutation } from "../baseMutation";
import { DeleteAuthTokenRequestForTest, DeleteAuthTokenResponseForTest } from "@maven-rest/sso/AuthToken.dto";
import { AuthTokenUrl } from "@maven-rest/sso/AuthToken.url";

export const useDeleteTokenMutation = () => {
  return useBaseMutation<DeleteAuthTokenResponseForTest, DeleteAuthTokenRequestForTest>({
    fnOption: {
      host: process.env.REACT_APP_SSO_BE_URL,
      url: AuthTokenUrl.deleteAuthToken,
    },
  });
};
